(ns graphs.core
  (:require
    [oops.core :refer [oget]]
    [reagent.format :as fmt]
    [reagent.core :as r]
    ["recharts" :as recharts]
    [css.core
     :as css
     :refer [defstyled]]
    [css.vars :as vars]))

(def graph-colors {:blue ["#001196" "#000A57" "#001AE3" "#0013A3" "#000E7D"]
                   :green ["#009617" "#06AC1F" "#00570D" "#00A319" "#007D13"]
                   :orange ["#966500" "#E39800" "#573A00" "#A36D00" "#7D5300"]
                   :red ["#960200" "#D80300" "#E30300" "#A30200" "#7D0200"]})

(defn percent-fmt [x]
  ((fnil #(fmt/format "%.2f%" %) 0) x))

(defn- pie-shape []
  (let [sector (r/adapt-react-class (oget recharts "Sector"))
        text (r/adapt-react-class (oget recharts "Text"))]
    (fn [{:keys [cx cy strategy] :as props}]
      [:g
       ;; label
       [text {:x cx
              :y cy
              :dy -8
              :textAnchor "middle"
              :fontSize "14"
              :width 115
              :style {:font-weight "bold"}} strategy]
       ;; percent value
       [text {:x cx
              :y cy
              :dy 12
              :textAnchor "middle"
              :fontSize "14"
              :style {:font-weight "bold"}} (percent-fmt (:percent props))]
       ;; internal ring
       [sector {:cx cx
                :cy cy
                :startAngle (:startAngle props)
                :endAngle (:endAngle props)
                :innerRadius (:innerRadius props)
                :outerRadius (:outerRadius props)
                :fill (:fill props)
                :style {:cursor "pointer"}}]
       ;; external ring
       [sector {:cx cx
                :cy cy
                :innerRadius (+ (:outerRadius props) 6)
                :outerRadius (+ (:outerRadius props) 15)
                :startAngle (:startAngle props)
                :endAngle (:endAngle props)
                :fill (:fill props)}]])))

(defn data->colors
  "This is a *working* way to iterate through the available colors and assign
  to a given data chunk a particular color. It will properly rotate through the
  colors AND each shade of color all the way before starting over. If your graph
  needs a crap-ton of colors (such that it flows back over), make a better
  graph."
  [data kw]
  (let [color-keys (vec (keys graph-colors))
        max-color-idx (reduce #(min %1 (count %2)) js/Infinity (vals graph-colors))]
    (loop [i 0
           shade 0
           kwd (get color-keys i)
           m {}
           d data]
      (if (nil? (first d))
        m
        (recur (inc i)
               (if (= 0 (mod (inc i) (count color-keys)))
                 (mod (inc shade) max-color-idx)
                 shade)
               (get color-keys (mod (inc i) (count color-keys)))
               (assoc m (get (first d) kw) (get (get graph-colors kwd) shade))
               (rest d))))))

(defstyled legend-label-s :span
  {:color vars/gray
   :font-size "1.16rem"
   :line-height "1.5rem"})

(defstyled legend-number-s :span
  {:color vars/gray
   :text-align "right"
   :font-size "1.16rem"
   :line-height "1.5rem"})

(defstyled legend-dot-s :div
  {:background-color (with-meta identity :color)
   :border-radius "100%"
   :height "1.25rem"
   :width "1.25rem"})

(defstyled legend-nest-s :span
  {:display "grid"
   :grid-template-columns "1.5rem 1fr auto"
   :grid-gap "0.5rem"
   :margin-top "2rem"
   :max-width "30rem"})

(defstyled legend-s :div
  { :margin "2rem 0 3rem"})

(defn chart-legend [data]
  (let [colors (data->colors data :id)]
  [legend-s
   (for [item data]
     ^{:key (:id item)}
     [legend-nest-s
      [legend-dot-s {:color (get colors (:id item))}]
      [legend-label-s (:name item)]
      [legend-number-s (percent-fmt (:percent item))]])]))

(defstyled pie-chart-s :div
  {:padding "1rem 0 1.5rem 0"})

(defn pie-chart []
  (let [responsive-container (r/adapt-react-class (oget recharts "ResponsiveContainer"))
        re-pie-chart (r/adapt-react-class (oget recharts "PieChart"))
        pie (r/adapt-react-class (oget recharts "Pie"))
        cell (r/adapt-react-class (oget recharts "Cell"))
        active-index (r/atom nil)]
    (fn [{:keys [data gen-on-mouse-enter opts] :or {gen-on-mouse-enter (fn [] #()) opts {}}}]
      (let [id->color (data->colors data :id)
            outer-radius (:outer-radius opts 100)
            inner-radius (:inner-radius opts 75)
            padding-angle (:padding-angle opts 1)]
        [pie-chart-s
         [responsive-container {:height (+ (* 2 outer-radius) 30)
                                :width (+ (* 2 outer-radius) 30)}
          [re-pie-chart {:on-mouse-leave #()}
           [pie {:activeIndex @active-index
                 :activeShape (r/create-element
                                (r/reactify-component pie-shape))
                 :data (clj->js data)
                 :dataKey "percent"
                 :innerRadius inner-radius
                 :isAnimationActive false
                 :on-click #()
                 ;; note this is *not* reagent's on-enter
                 :onMouseEnter (gen-on-mouse-enter active-index)
                 :outerRadius outer-radius
                 :paddingAngle padding-angle}
            (for [c data]
              ^{:key (:id c)}
              [cell {:fill (id->color (:id c))}])]]]]))))
